import { render } from "./SwapContactCard.vue?vue&type=template&id=2b670076&scoped=true"
import script from "./SwapContactCard.vue?vue&type=script&lang=js"
export * from "./SwapContactCard.vue?vue&type=script&lang=js"

import "./SwapContactCard.vue?vue&type=style&index=0&id=2b670076&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b670076"]])

export default __exports__